import { z } from 'zod';
// Sign-in input
export const SignInInputDTOSchema = z.object({
    email: z.email(),
    password: z.string().min(8),
    rememberMe: z.boolean().optional(),
});
// Sign-in request (HTTP structure)
export const SignInRequestDTOSchema = z.object({
    body: SignInInputDTOSchema,
});
//# sourceMappingURL=sign-in.dto.js.map